import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img
                src="https://static.readdy.ai/image/6b209d8241a0edcb1fce2c73c5c3e926/02feb5e062d9c04b5a9337239e09382c.png"
                alt="Amaca S.r.l."
                className="h-16 w-auto object-contain"
              />
              <span className="text-2xl font-bold">Amaca S.r.l.</span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md leading-relaxed">
              Il tuo partner di fiducia per il commercio all'ingrosso di computer, cellulari e software. Qualità garantita, prezzi competitivi e servizio professionale dal 2020.
            </p>
            <div className="space-y-2 text-sm text-gray-300 mb-6">
              <p className="font-semibold text-white">Amaca S.r.l.</p>
              <p>Via Don Domenico D'Angelo 31</p>
              <p>80025 Casandrino (NA)</p>
              <p>P.IVA: 10914011217</p>
              <p className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:+393508628049" className="hover:text-white transition-colors cursor-pointer">
                  350 862 8049
                </a>
              </p>
              <p className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <a href="mailto:ordini.amacasrl@gmail.com" className="hover:text-white transition-colors cursor-pointer">
                  ordini.amacasrl@gmail.com
                </a>
              </p>
              <p className="flex items-center">
                <i className="ri-mail-send-line mr-2"></i>
                <a href="mailto:amacasrl2025@pec.it" className="hover:text-white transition-colors cursor-pointer">
                  amacasrl2025@pec.it
                </a>
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Prodotti</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/prodotti" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Computer e Notebook
                </Link>
              </li>
              <li>
                <Link to="/prodotti" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Smartphone e Tablet
                </Link>
              </li>
              <li>
                <Link to="/prodotti" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Software e Licenze
                </Link>
              </li>
              <li>
                <Link to="/prodotti" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Accessori e Periferiche
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Azienda</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/chi-siamo" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Chi Siamo
                </Link>
              </li>
              <li>
                <Link to="/servizi" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Servizi
                </Link>
              </li>
              <li>
                <Link to="/contatti" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Contatti
                </Link>
              </li>
              <li>
                <Link to="/info-legali" className="text-gray-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Info Legali
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <p className="text-gray-400 text-sm text-center">
            © 2025 Amaca S.r.l. Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
